import { render, staticRenderFns } from "./partner-carousel.vue?vue&type=template&id=f03223fe&scoped=true"
import script from "./partner-carousel.vue?vue&type=script&lang=js"
export * from "./partner-carousel.vue?vue&type=script&lang=js"
import style0 from "./partner-carousel.vue?vue&type=style&index=0&id=f03223fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03223fe",
  null
  
)

export default component.exports